import {
  FlyerDetailPageFormPageActions,
  FlyerDetailPageFormPageActionType,
} from "./flyer-detail-page-form-page.actions";
import { FlyerDetailPageFormPageState } from "../types/flyer-detail-page-form-page-state/flyer-detail-page-form-page-state.interface";
import { createFlyerDetailPageFormPageState } from "../types/flyer-detail-page-form-page-state/flyer-detail-page-form-page-state.functions";

export function flyerDetailPageFormPageReducer(
  state = createFlyerDetailPageFormPageState(),
  action: FlyerDetailPageFormPageActionType
): FlyerDetailPageFormPageState {
  switch (action.type) {
    case FlyerDetailPageFormPageActions.FetchPage:
    case FlyerDetailPageFormPageActions.SavePage:
      return {
        ...state,
        isLoading: true,
      };
    case FlyerDetailPageFormPageActions.SavePageSuccess:
    case FlyerDetailPageFormPageActions.FetchPageSuccess:
      return {
        ...state,
        isLoading: false,
        page: action.payload,
      };
    case FlyerDetailPageFormPageActions.FetchPageFailure:
    case FlyerDetailPageFormPageActions.SavePageFailure:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FlyerDetailPageFormPageActions.Reset:
      return createFlyerDetailPageFormPageState();

    default:
      return state;
  }
}
